import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import FileListItem from "../file-list-item";

const FileColumn = ({ column }) => {
  const mappedCount = column.list.filter((item) => item.token).length;

  return (
    <Box
      sx={{
        border: 1,
        borderColor: "divider",
        borderRadius: 1,
        p: 1.5,
        width: "60%",
        minHeight: 0,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <Box sx={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", mb: 1, gap: 1 }}>
        <Typography variant="subtitle2">{column.name}</Typography>
        <Typography variant="caption" color="text.secondary" noWrap>
          {mappedCount} of {column.list.length} mapped
        </Typography>
      </Box>
      <Box sx={{ overflowY: "auto", overflowX: "hidden", minHeight: 0, flex: 1 }}>
        {column.list.map((itemObject, index) => (
          <FileListItem key={itemObject.id} index={index} itemObject={itemObject} />
        ))}
      </Box>
    </Box>
  );
};

export default FileColumn;
